<template>
    <div>
        <Table :no-data-text="$t('common.noData')" class="table-css" :columns="columns" :data="tableSecurityData" height="470" :loading="securityLoadings" style="width: 100.1%;"></Table>
    </div>
</template>
<script>
    import TableExpand from '../security/TableExpand.vue';
    var tableSecurityVue = {};
    export default {
        name: 'TableSecurity',
        components: { TableExpand },
        data () {
            return {
                securityLoadings: false,
                accountIdSearchKey:'',
                regionSearchKey:'',
                eventNameSearchKey:'',
                eventTypeSearchKey:'',
                agentDate:'',
                columns: [
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(TableExpand, {
                                props: {
                                    row: params.row
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('ActionTrailSecurity.accountName'),
                        key: 'accountName',
                    },
                    {
                        title: this.$t('ActionTrailSecurity.eventTime'),
                        key: 'eventTime',
                    },
                    {
                        title: this.$t('ActionTrailSecurity.userName'),
                        key: 'userName'
                    },
                    {
                        title: this.$t('ActionTrailSecurity.eventName'),
                        key: 'eventName'
                    },
                    {
                        title: this.$t('ActionTrailSecurity.resourceType'),
                        key: 'resourceType'
                    },
                    {
                        title: this.$t('ActionTrailSecurity.resourceName'),
                        key: 'resourceName'
                    },
                    {
                        title: this.$t('ActionTrailSecurity.errorCode'),
                        key: 'errorCode'
                    }
                ],
                tableSecurityData:[]
            }
        },
        beforeCreate: function() {
            tableSecurityVue = this
        },
        methods:{
            showAll: function(accountIdSearchKey,regionSearchKey,eventNameSearchKey,eventTypeSearchKey,agentDate){
                tableSecurityVue.accountIdSearchKey = accountIdSearchKey;
                tableSecurityVue.regionSearchKey = regionSearchKey;
                tableSecurityVue.eventNameSearchKey = eventNameSearchKey;
                tableSecurityVue.eventTypeSearchKey = eventTypeSearchKey;
                tableSecurityVue.agentDate = agentDate;
                tableSecurityVue.getSecurityData();
            },
            // 显示数据
            /****************************************************/
            getSecurityData:function() {
                this.securityLoadings = true;
                this.$api.actionTrail.listActionTrailEvent({
                    "accountIds" : tableSecurityVue.accountIdSearchKey,
                    "regionId" : tableSecurityVue.regionSearchKey,
                    "eventNames" : tableSecurityVue.eventNameSearchKey,
                    "eventRW" : tableSecurityVue.eventTypeSearchKey,
                    "timeList" : tableSecurityVue.agentDate   
                })
                .then(res => {
                    this.tableSecurityData = res.data.actionTrailEventDTOList;
                    this.securityLoadings = false;
                });
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/security/TableSecurity.vue